module.exports = __webpack_public_path__ + "img/logo.d44f0b25.png";